import { connect, ConnectedProps } from 'react-redux'

import LegislationAccordionSkeleton from 'components/accordion/LegislationAccordionSkeleton'
import { RootState } from 'redux/store'

const mapStateToProps = (state: RootState): { windowHeight: RootState['layout']['windowHeight'], headerHeight: RootState['layout']['headerHeight'], deviceType: RootState['layout']['deviceType'] } => ({
  windowHeight: state.layout.windowHeight,
  headerHeight: state.layout.headerHeight,
  deviceType: state.layout.deviceType
})

export const connector = connect(mapStateToProps, null)
export type LegislationAccodionSkeletonContainerProps = ConnectedProps<typeof connector>

export default connector(LegislationAccordionSkeleton)
